// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Clients from './components/Clients';
import EditClient from './components/EditClient';
import Tasks from './components/Tasks';
import EditTask from './components/EditTask';
import Meetings from './components/Meetings';
import EditMeeting from './components/EditMeeting';
import Finances from './components/Finances';
import Alerts from './components/Alerts';
import Users from './components/Users';
import ActivityLogs from './components/ActivityLogs';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './components/MainLayout';
import EditAlert from './components/EditAlert';
import ProductCalculator from './components/ProductCalculator'; // Dodaj ten import
import Expenses from './components/Expenses'; // Dodaj ten import
import DocumentList from './components/DocumentList';
import DocumentDetails from './components/DocumentDetails';
import AddDocument from './components/AddDocument';
<Route path="/expenses/:id" element={<DocumentDetails />} />

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<PrivateRoute><MainLayout /></PrivateRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/edit/:id" element={<EditClient />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/tasks/edit/:id" element={<EditTask />} />
          <Route path="/meetings" element={<Meetings />} />
          <Route path="/meetings/edit/:id" element={<EditMeeting />} />
          <Route path="/finances" element={<Finances />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/users" element={<Users />} />
          <Route path="/activity-logs" element={<ActivityLogs />} />
          <Route path="/alerts/edit/:id" element={<EditAlert />} />
          <Route path="/calculator" element={<ProductCalculator />} />
          <Route path="/expense" element={<AddDocument />} />
          <Route path="/documentlist" element={<DocumentList />} />
          <Route path="/expenses/:id" element={<DocumentDetails />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;